import React, {Component} from 'react';
import Header from './Header';

export default class Maintenance extends Component {
    state = {};

    render() {
        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content" style={{
                    flexDirection: 'column',
                    padding: 50
                }}>
                    <h1 style={{fontSize: 60, color: '#344A5E'}}>MAINTENANCE MODE</h1>
                    <h2 style={{
                        fontSize: 42,
                        fontWeight: 'bold',
                        color: '#344A5E',
                        textAlign: 'center'
                    }}>
                        Hi,<br/>
                        Emitto is currently under a scheduled maintenance slot<br/>
                        <span style={{color: '#18A9E3'}}>11 am - 1 pm UTC</span>
                    </h2>
                    <h2 style={{
                        fontSize: 42,
                        fontWeight: 'bold',
                        color: '#344A5E',
                        textAlign: 'center',
                        marginTop: 100,
                        marginBottom: 20
                    }}>
                        Thank you for your patience.
                    </h2>
                    <p style={{
                        color: '#344A5E',
                        fontSize: 26,
                        fontWeight: 'bold'
                    }}>For any details contact <a href="mailto:support@emitto.io">support@emitto.io</a></p>
                </div>
            </div>
        )
    }
}